import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonContent, IonPage, useIonViewWillEnter } from '@ionic/react'
import { MktEmpty, UseHeader } from '@cps'
import { ActivityAPI } from '@api/index'
import { useHistoryNew, getPlatform } from '@utils'
import mktController from 'controllers/mktController'
import defaultImg from '@img/default-longMallProduct.png'
import {
  formatDateOnlyRange,
  getActivityId,
  getActivityName,
  getCover,
  getEndAt,
  getRemain,
  getStartAt,
  isFreeActivity,
  normalizeList
} from '../utils'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const { isWeixinMiniProgram } = getPlatform()

const ActivityReserveList: FC<IProps> = () => {
  const history = useHistoryNew()
  const [list, setList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const getData = () => {
    setLoading(true)
    ActivityAPI.getActivityReserveList({
      brandId: Config.BRANDID,
      page: 1,
      pageSize: 20,
    }).then((res: any) => {
      if (!res?.errors) {
        setList(normalizeList(res))
      }
    }).catch(() => {
      setList([])
    }).finally(() => setLoading(false))
  }

  const goDetail = (item: any) => {
    history.push(`/activityReserve/detail/${getActivityId(item)}`)
  }

  const initShareData = () => {
    mktController.initShareData({
      url: isWeixinMiniProgram ? `/pages/launch/index?jumpH5Page=${encodeURIComponent(location.href)}` : location.href,
      title: i18n.t('mkt.activityReserve.title'),
    })
  }

  useIonViewWillEnter(() => {
    getData()
    initShareData()
  })

  return (
    <IonPage className='activity-reserve-list-page'>
      <UseHeader title={i18n.t('mkt.activityReserve.title')} onBack={() => mktController.goBack(history)}></UseHeader>
      <IonContent className='page-content'>
        <div className='activity-reserve-list-body'>
          {!loading && list.length === 0 && <MktEmpty text={i18n.t('mkt.activityReserve.noActivities')} des={i18n.t('mkt.activityReserve.noActivitiesDesc')} />}
          {list.map((item: any) => {
            const remain = getRemain(item)
            const isFree = isFreeActivity(item)
            return (
              <div className='activity-card' key={getActivityId(item)} onClick={() => goDetail(item)}>
                <div className='activity-card-cover' style={{ backgroundImage: `url(${getCover(item) || defaultImg})` }}>
                  {isFree && <span className='activity-card-fee-tag'>{i18n.t('mkt.activityReserve.free')}</span>}
                </div>
                <div className='activity-card-info'>
                  <div className='activity-card-title'>{getActivityName(item)}</div>
                  <div className='activity-card-time'>{formatDateOnlyRange(getStartAt(item), getEndAt(item))}</div>
                  {remain >= 0 && (
                    <div className='activity-card-footer'>
                      <span className='activity-card-remain'>{remain > 0 ? i18n.t('mkt.activityReserve.remaining', { count: remain }) : i18n.t('mkt.activityReserve.fullyBooked')}</span>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(ActivityReserveList)
